import assert from 'assert'
import { ReactNodeArray } from 'prop-types'
import { Children, ReactElement } from 'react'

import styled from 'styled-components'

const validInlineComponents = ['div', 'ol', 'ul'] as const

type Space = number | 'none'
interface SpaceProps {
  readonly space: Space
}

const NegativeMargin = styled.div<SpaceProps>`
  margin-top: -${props => props.space};
`

const Wrapper = styled.div<SpaceProps>`
  margin-left: -${props => props.space};
  display: flex;
  flex-wrap: wrap;
`

const Item = styled.div<SpaceProps>`
  min-width: 0;
  margin-top: ${props => props.space};
  margin-left: ${props => props.space};
`

export type ReactNodeNoStrings = ReactElement | ReactNodeArray | boolean | null | undefined

export interface InlineProps {
  space: Space
  component?: (typeof validInlineComponents)[number]
  children: ReactNodeNoStrings
}

const Inline = ({
  space = 'none',
  // align,
  // alignY,
  // collapseBelow,
  // reverse,
  component = 'div',
  children
}: InlineProps): JSX.Element => {
  assert(
    validInlineComponents.includes(component),
    `Invalid Inline component: '${component}'. Should be one of [${validInlineComponents
      .map(c => `'${c}'`)
      .join(', ')}]`
  )

  const isList = component === 'ol' || component === 'ul'
  const inlineItemComponent = isList ? 'li' : 'div'

  return (
    <NegativeMargin space={space}>
      <Wrapper space={space} as={component}>
        {Children.map(children, child =>
          child !== null && child !== undefined ? (
            <Item as={inlineItemComponent} space={space}>
              {child}
            </Item>
          ) : null
        )}
      </Wrapper>
    </NegativeMargin>
  )
}

export default Inline
